import { Box } from '@mui/material';
import InfiniteLoopAnimation from 'Application/components/LoginLoader';
import { useAuthStore } from 'Application/store';
import { deleteUserDataFromStorage, getUserDataFromStorage, mapUserRoleToHomeRoute } from 'Application/utils';
import { FC, ReactNode, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';

interface AuthRedirectRouteProps {
    component: ReactNode;
}

export const AuthRedirectRoute: FC<AuthRedirectRouteProps> = ({ component }) => {
    const user = getUserDataFromStorage();

    const { authData, refreshToken, isError } = useAuthStore();

    const navigate = useNavigate();

    useEffect(() => {
        refreshToken();
    }, []);

    useEffect(() => {
        if (authData) {
            if (user !== null && authData.loggedIn) {
                toast.info('You are already logged in');
                const userRole = user.role;
                setTimeout(() => {
                    navigate(mapUserRoleToHomeRoute(userRole));
                }, 3000);
            }
        }

        if (isError) {
            deleteUserDataFromStorage();
        }
    }, [isError, authData?.loggedIn]);

    if (user !== null) {
        return (
            <Box className="w-full h-[100vh] flex justify-center items-center">
                <InfiniteLoopAnimation height={150} width={150} />
            </Box>
        );
    }

    return component;
};
